import React from 'react'
import { Route, Routes } from 'react-router-dom'
import MediaGallery from "../Pages/MediaGallery/MediaGallery";
import Documents from "../Pages/Documents/Documents"
import TermsConditions from '../Pages/TermsConditions';
import Authenticate from '../Pages/Authenticate';
import AuthenticatedRoute from './AuthenticatedRoute';
import AccessDenied from '../Pages/AccessDenied/AccessDenied';
import { useSelector } from 'react-redux';

const AppRoute = () => {
    const isAuthenticated = useSelector(state => state.user);

    return (
        <Routes>
            <Route path='/portals-login' element={<Authenticate />} />

            <Route element={<AuthenticatedRoute isAuthenticated={isAuthenticated} />}>
                <Route path='/' element={<MediaGallery />} />
                <Route path='/documents' element={<Documents />} />
                <Route path='/termsConditions' element={<TermsConditions />} />
            </Route>

            <Route path="/access-denied" element={<AccessDenied />} />
        </Routes>
    )
}

export default AppRoute